import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/index.vue'),
    meta: {
      showHead: false //首页不显示head组件
    }
  },

  {
    path: '/chooseClass',
    name: 'chooseClass',
    component: () => import('../views/chooseClass.vue'),
    meta: {
      title: '选课', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/myClass',
    name: 'myClass',
    component: () => import('../views/myClass.vue'),
    meta: {
      title: '学习', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/newUser',
    name: 'newUser',
    component: () => import('../views/newUser/newUser.vue'),
    meta: {
      title: '邀请新用户', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/my',
    name: 'my',
    component: () => import('../views/my.vue'),
    meta: {
      showHead: false
      // title: '个人中心', // 必选：显示标题
      // showLeft: false, // 可选：控制左侧图标
      // showHead:true,// 可选：控制整个head组件
      // fixedTop:false,// 可选：是否固定在顶部
    }
  },
  {
    path: '/userInfo',
    name: 'userInfo',
    component: () => import('../views/userInfo.vue'),
    meta: {
      title: '个人资料', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },

  {
    path: '/balance',
    name: 'balance',
    component: () => import('../views/balance/balance.vue'),
    meta: {
      title: '我的余额', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },

  {
    path: '/certificate',
    name: 'certificate',
    component: () => import('../views/certificate/certificate.vue'),
    meta: {
      title: '我的证书', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/applyFor',
    name: 'applyFor',
    component: () => import('../views/certificate/applyFor.vue'),
    meta: {
      title: '证书申领', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/weixin',
    name: 'weixin',
    component: () => import('../views/announcement/weixin.vue'),
    meta: {
      title: '微信客服', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/combined',
    name: 'combined',
    component: () => import('../views/certificate/combined.vue'),
    meta: {
      title: '合并学时', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/myInvoice',
    name: 'myInvoice',
    component: () => import('../views/myInvoice/myInvoice.vue'),
    meta: {
      title: '我的发票', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/zscy',
    name: 'zscy',
    component: () => import('../views/zscy/zscy.vue'),
    meta: {
      title: '证书查验', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/myOrder',
    name: 'myOrder',
    component: () => import('../views/myOrder/myOrder.vue'),
    meta: {
      title: '我的订单', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/invoicing',
    name: 'invoicing',
    component: () => import('../views/myInvoice/invoicing.vue'),
    meta: {
      title: '开发票', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/membership',
    name: 'membership',
    component: () => import('../views/membership/membership.vue'),
    meta: {
      title: '会员权益', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/announcement',
    name: 'announcement',
    component: () => import('../views/announcement/announcement.vue'),
    meta: {
      title: '公告资讯', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/balance',
    name: 'balance',
    component: () => import('../views/balance/balance.vue'),
    meta: {
      title: '我的余额', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/player',
    name: 'player',
    component: () => import('../views/player/player.vue'),
    meta: {
      title: '详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/chapter',
    name: 'chapter',
    component: () => import('../views/class/chapter.vue'),
    meta: {
      title: '课程目录', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/select',
    name: 'select',
    component: () => import('../views/select/select.vue'),
    meta: {
      title: '搜索', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/selectPage',
    name: 'selectPage',
    component: () => import('../views/selectPage/selectPage.vue'),
    meta: {
      title: '搜索结果', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/zyDetail',
    name: 'zyDetail',
    component: () => import('../views/zyDetail/zyDetail.vue'),
    meta: {
      title: '详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/noticeDetail',
    name: 'noticeDetail',
    component: () => import('../views/announcement/noticeDetail.vue'),
    meta: {
      title: '详情', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/practice',
    name: 'practice',
    component: () => import('../views/practice/practice.vue'),
    meta: {
      title: '模拟练习', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/classDetail',
    name: 'classDetail',
    component: () => import('../views/classDetail/classDetail.vue'),
    meta: {
      title: '班级详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/login.vue'),
    meta: {
      title: '登录', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/resource',
    name: 'resource',
    component: () => import('../views/membership/resource.vue'),
    meta: {
      title: '课程资源库', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/vipPage',
    name: 'vipPage',
    component: () => import('../views/membership/vipPage.vue'),
    meta: {
      title: '开通会员', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register/register.vue'),
    meta: {
      title: '注册', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/paySuccess',
    name: 'paySuccess',
    component: () => import('../views/paySuccess/paySuccess.vue'),
    meta: {
      title: '支付成功', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/pintuan',
    name: 'pintuan',
    component: () => import('../views/pintuan/pintuan.vue'),
    meta: {
      title: '拼团选课', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/jifen',
    name: 'jifen',
    component: () => import('../views/jifen/jifen.vue'),
    meta: {
      title: '我的积分', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/updateUser',
    name: 'updateUser',
    component: () => import('../views/updateUser/updateUser.vue'),
    meta: {
      title: '修改个人资料', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/payType',
    name: 'payType',
    component: () => import('../views/payType/payType.vue'),
    meta: {
      title: '收银台', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/queryPay',
    name: 'queryPay',
    component: () => import('../views/queryPay/queryPay.vue'),
    meta: {
      title: '收银台', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/exam',
    name: 'exam',
    component: () => import('../views/exam/exam.vue'),
    meta: {
      title: '考试', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/courseDetail',
    name: 'courseDetail',
    component: () => import('../views/courseDetail/courseDetail.vue'),
    meta: {
      title: '课程详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/tryPlaying',
    name: 'tryPlaying',
    component: () => import('../views/tryPlaying/tryPlaying.vue'),
    meta: {
      title: '试看', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  }
  ,
  {
    path: '/kczyktryPlaying',
    name: 'kczyktryPlaying',
    component: () => import('../views/tryPlaying/kczyktryPlaying.vue'),
    meta: {
      title: '试看', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  }
  ,
  {
    path: '/zyPlayer',
    name: 'zyPlayer',
    component: () => import('../views/zyPlayer/zyPlayer.vue'),
    meta: {
      title: '视频详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/zykPlayer',
    name: 'zykPlayer',
    component: () => import('../views/zykPlay/zykPlayer.vue'),
    meta: {
      title: '视频详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/zykPlayer2',
    name: 'zykPlayer2',
    component: () => import('../views/zykPlay/zykPlayer2.vue'),
    meta: {
      title: '视频详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/list',
    name: 'list',
    component: () => import('../views/zscy/list.vue'),
    meta: {
      title: '证书查验列表', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/zsCan',
    name: 'zsCan',
    component: () => import('../views/certificate/zsCan.vue'),
    meta: {
      title: '证书详情', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/studyList',
    name: 'studyList',
    component: () => import('../views/zscy/stydyList.vue'),
    meta: {
      title: '学时查验列表', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/classHour',
    name: 'classHour',
    component: () => import('../views/zscy/classHour.vue'),
    meta: {
      title: '学时证明详情', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/myInvoiceDetail',
    name: 'myInvoiceDetail',
    component: () => import('../views/myInvoice/myInvoiceDetail.vue'),
    meta: {
      title: '发票详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/registerXy',
    name: 'registerXy',
    component: () => import('../views/registerXy/registerXy.vue'),
    meta: {
      title: '用户协议', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import('../views/membership/agreement.vue'),
    meta: {
      title: '会员服务协议', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/examDetail',
    name: 'examDetail',
    component: () => import('../views/examDetail/examDetail.vue'),
    meta: {
      title: '考试详情', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  },
  {
    path: '/studyExam',
    name: 'studyExam',
    component: () => import('../views/studyExam/studyExam.vue'),
    meta: {
      title: '考试中', // 必选：显示标题
      showLeft: false, // 可选：控制左侧图标
      showHead: false, // 可选：控制整个head组件
      fixedTop: false // 可选：是否固定在顶部
    }
  },
  {
    path: '/chapterList',
    name: 'chapterList',
    component: () => import('../views/chapterList/chapterList.vue'),
    meta: {
      title: '章节列表', // 必选：显示标题
      showLeft: true, // 可选：控制左侧图标
      showHead: true, // 可选：控制整个head组件
      fixedTop: true // 可选：是否固定在顶部
    }
  }

  //     ,
  // {
  //   path: '/resourceDetail',
  //   name: 'resourceDetail',
  //   component: () => import('../views/membership/resourceDetail.vue'),
  //   meta: {
  // title: '课程资源库详情', // 必选：显示标题
  //     showLeft: true, // 可选：控制左侧图标
  //     showHead: true, // 可选：控制整个head组件
  //     fixedTop: false // 可选：是否固定在顶部
  //   }
  // }
];

const router = new VueRouter({
  mode: 'history', // 切换到HTML5 History模式
  routes
});

export default router;
